import {currencyOptions} from '../../data';

import './style.scss';

const ListItem = (props) => {
  //   const { title, amount, category } = props;
  const { category, title, amount, type,  deleteItem, id } = props;
  return (
    <li className="listItem" id={id} data-type={type}>
      <p className="category">{category} </p>
      <p className="title">{title} </p>
      <p className="amount">{amount.toLocaleString(undefined, currencyOptions)} </p>
      <button onClick={(e) => deleteItem(e)} className='deleteItem'></button>
    </li>
  );
};

export default ListItem;
